import { NgModule } from '@angular/core';
import { CmsActionsComponent } from './cms-actions/cms-actions.component';
import { CmsEntityManagementNavComponent } from './cms-entity-management-nav/cms-entity-management-nav.component';
import { CmsEntityManagementInnerSectionNavComponent } from './cms-entity-management-inner-section-nav/cms-entity-management-inner-section-nav.component';
import { CmsLayoutComponent } from './cms-layout/cms-layout.component';
import { CmsNavigationComponent } from './cms-navigation/cms-navigation.component';
import { ButtonComponent } from '../button/button.component';
import { IconModule } from '../icon/icon.module';
import { SharedModule } from '../../modules/shared/shared.module';
import { CommonModule } from '@angular/common';

const COMPONENTS = [
  CmsActionsComponent,
  CmsEntityManagementNavComponent,
  CmsEntityManagementInnerSectionNavComponent,
  CmsLayoutComponent,
  CmsNavigationComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, ButtonComponent, IconModule, SharedModule],
  exports: [...COMPONENTS],
})
export class CmsModule {}
